/**
 * This file is part of Instrumenpoche.
 *   Copyright 2014-2015, Association Sésamath
 *
 * Instrumenpoche is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License version 3
 * as published by the Free Software Foundation.
 *
 * Instrumenpoche is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with SesaReactComponent (LICENCE.txt).
 * @see http://www.gnu.org/licenses/agpl.txt
 *
 *
 * Ce fichier fait partie de SesaReactComponent, créée par l'association Sésamath.
 *
 * Instrumenpoche est un logiciel libre ; vous pouvez le redistribuer ou le modifier suivant
 * les termes de la GNU Affero General Public License version 3 telle que publiée par la
 * Free Software Foundation.
 * Instrumenpoche est distribué dans l'espoir qu'il sera utile, mais SANS AUCUNE GARANTIE,
 * sans même la garantie tacite de QUALITÉ MARCHANDE ou d'ADÉQUATION à UN BUT PARTICULIER.
 * Consultez la GNU Affero General Public License pour plus de détails.
 * Vous devez avoir reçu une copie de la GNU General Public License en même temps que SesaQcm
 * (cf LICENCE.txt et http://vvlibri.org/fr/Analyse/gnu-affero-general-public-license-v3-analyse
 * pour une explication en français)
 */
'use strict'
/* eslint-env browser */
const { addJs } = require('sesajstools/dom')

const mathJaxUrl = 'https://www.mathgraph32.org/js/MathJax/MathJax.js?config=TeX-AMS-MML_SVG-full'
const configCode = `MathJax.Hub.Config({
  tex2jax: {
    inlineMath: [['$', '$'],['\\\\(', '\\\\)']]
  },
  jax: ['input/TeX','output/SVG'],
  TeX: {extensions: ['color.js']},
  messageStyle:'none'
});`
// en s
const loadDelay = 10

// La 1re promesse de chargement qui sera créée, puis renvoyée lors de tous les appels
// (ça permet de ne lancer qu'un seul chargement même en cas d'appels multiples avant que MathJax ne soit complètement chargé)
let firstLoadingPromise

/**
 * Charge mathjax dans le <head> de la page courante
 * (appelé par le prepare de ActionEcrireTexte et ActionNommerPoint,
 * donc déclenche le chargement dès que le tableau des actions est construit,
 * seulement si l'une des actions a besoin de Mathjax)
 * @private
 * @return {Promise}
 */
module.exports = function mathjaxLoader () {
  // Au 1er appel on charge MathJax
  if (!firstLoadingPromise) {
    if (typeof MathJax === 'undefined') {
      // faut le charger
      firstLoadingPromise = new Promise((resolve, reject) => {
        const head = window.document.getElementsByTagName('head')[0]
        // la config
        const eltConfig = window.document.createElement('script')
        eltConfig.type = 'text/x-mathjax-config'
        eltConfig.appendChild(window.document.createTextNode(configCode))
        head.appendChild(eltConfig)
        // load du js
        addJs(mathJaxUrl, () => {
          clearTimeout(timeout)
          resolve()
        })
        // on ajoute un timeout de chargement
        const timeout = setTimeout(() => {
          // on reset pour que le prochain appel relance un chargement
          firstLoadingPromise = null
          reject(Error(`Mathjax non chargé après ${loadDelay}s d’attente`))
        }, loadDelay * 1000)
      })
    } else {
      // on avait déjà chargé MathJax avant le 1er appel de cette fct, on le garde
      console.log('MathJax était déjà chargé, on ne fait rien')
      firstLoadingPromise = Promise.resolve()
    }
  }
  return firstLoadingPromise
}
